//@flow
import React from 'react'
import PropTypes from 'prop-types'

import { useIpbxApi, useObserver } from '~/core/utils/hooks'
import { AcceptTemplate } from 'components/common/modal/templates'
import { useI18n } from '~/core/i18n'

const getServiceUrl = type => {
  switch (type) {
    case 'modular-reload':
      return '/service/reload?type=modular'
    case 'full-reload':
      return '/service/reload'
    case 'restart':
    default:
      return '/service/restart'
  }
}

type ApplyChangesModalProps = {
  type: 'modular-reload' | 'full-reload' | 'restart',
  onSuccess?: () => void,
  onLoadingStateChange?: (isLoading: boolean) => void
}

const ApplyChangesModal = ({ type, onLoadingStateChange = () => {}, onSuccess = () => {} }: ApplyChangesModalProps) => {
  const [msg] = useI18n()
  const [{ error, data, loading }, runService] = useIpbxApi({})

  const handleRunService = () =>
    runService({
      method: 'PUT',
      url: getServiceUrl(type),
      timeout: 90000
    })

  useObserver(data, onSuccess)
  useObserver(loading, () => onLoadingStateChange(loading))

  return (
    <AcceptTemplate
      error={error}
      isLoading={loading}
      text={msg('system.applychanges.content.acceptText', { type: type === 'restart' ? 'restart' : 'reload' })}
      onAccept={handleRunService}
    />
  )
}

ApplyChangesModal.propTypes = {
  type: PropTypes.oneOf(['restart', 'reload']),
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
}

export default ApplyChangesModal
